import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  UpdateWebsiteRedirectsInput,
  WebsiteRedirectConfiguration,
} from './website-redirects.types'

export interface WebsiteRedirectOrganizationScope {
  organizationId: OrganizationId
}

/** Query functions read only the key. */
type WebsiteRedirectQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export async function getWebsiteRedirects({
  queryKey: [{ organizationId }],
}: WebsiteRedirectQueryContext<WebsiteRedirectOrganizationScope>) {
  return axios.get<WebsiteRedirectConfiguration>(
    '/website-redirects',
    buildAdminRequestConfig({ organizationId })
  )
}

/** Replaces every redirect and resolves to the saved configuration. */
export async function updateWebsiteRedirects({
  organizationId,
  values,
}: WebsiteRedirectOrganizationScope & { values: UpdateWebsiteRedirectsInput }) {
  return axios.put<WebsiteRedirectConfiguration>(
    '/website-redirects',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}
